"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlappingInMinutes = void 0;
const lodash_1 = require("lodash");
/**
 * 2つのPeriodがかぶっている時間を算出する。
 * 単純にAND演算の結果を利用できる
 * @param pa
 * @param pb
 * @returns
 */
const overlappingInMinutes = (pa, pb) => {
    const andResult = pa.and(pb);
    if ((0, lodash_1.isNull)(andResult)) {
        return 0;
    }
    return andResult.lengthInMinutes();
};
exports.overlappingInMinutes = overlappingInMinutes;
//# sourceMappingURL=overlappingInMinutes.js.map